// ============================================
// Google Harita SEO - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleHaritaSeoContent: BlogContent = {
  tableOfContents: [
    { id: "harita-seo-nedir", title: "Harita SEO Nedir?" },
    { id: "optimizasyon", title: "Optimizasyon Stratejileri" },
    { id: "yerel-arama", title: "Yerel Arama" },
    { id: "basari-metrikleri", title: "Başarı Metrikleri" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google Harita SEO</strong> stratejileri ve yerel arama optimizasyonu teknikleri."
    }
  ]
};

export default googleHaritaSeoContent;
